// Lightweight first-party analytics beacon — powers the admin Analytics page
// (sessions, top pages, traffic sources, and the live visitor map). No
// cookies, no third-party script; just a sessionStorage id + a fetch/beacon
// ping to our own API.
const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const SESSION_KEY = 'nq_session_id';

function getSessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    // Private browsing / storage disabled — fall back to an in-memory id
    // (each call becomes its own "session", which is an acceptable degrade).
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
  }
}

export function trackVisit(path, opts = {}) {
  try {
    const payload = JSON.stringify({
      sessionId: getSessionId(),
      path: path || window.location.pathname,
      referrer: document.referrer || '',
      // Heartbeat pings (fired every 20s while a tab stays open on the same
      // page) keep the visitor "live" but must NOT count as a new page view —
      // only an actual navigation to a page should increment the view count.
      isHeartbeat: !!opts.heartbeat,
    });
    const url = `${BASE}/api/track`;
    // sendBeacon survives page unloads/tab closes; fall back to fetch.
    if (navigator.sendBeacon) {
      const blob = new Blob([payload], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
    } else {
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, keepalive: true }).catch(() => {});
    }
  } catch {
    /* analytics must never break the storefront */
  }
}

// Fires a funnel event (currently just add-to-cart) to /api/track/event.
// Powers the "Live right now" realtime panel on the admin Analytics page.
export function trackAddToCart(meta = {}) {
  try {
    const payload = JSON.stringify({ sessionId: getSessionId(), type: 'add_to_cart', meta });
    const url = `${BASE}/api/track/event`;
    if (navigator.sendBeacon) {
      const blob = new Blob([payload], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
    } else {
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, keepalive: true }).catch(() => {});
    }
  } catch {
    /* analytics must never break the storefront */
  }
}